import { escapeRegExp } from "modules/utils/Functions";

function buildRegex(query: string[]) {
  const _query = query
    .filter((text) => text.length !== 0)
    .map((text) => escapeRegExp(text.trim()));
  if (!_query.length) {
    return undefined;
  }

  return new RegExp(`(${_query.join("|")})`, "ig");
}

const highlightWordsRegex = (query: string | string[] | null) =>
  query ? buildRegex(Array.isArray(query) ? query : [query]) : undefined;

export default highlightWordsRegex;
